import React from 'react';
import '../../styles/footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2025 GrowTheory. Powered by AWS Bedrock.</p>
      </div>
    </footer>
  );
};

export default Footer;
